import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import {
  microHeading,
  baseCaption,
  font,
  lineHeight,
} from "../theme/typography";
import { semiBold } from "../theme/typeface";
import {
  black400,
  black500,
  black600,
  blue100,
  cinnabar300,
} from "../theme/colors";
import themeSizes from "../theme/themeSizes";
import { ToolTip } from "./ToolTip";
import InfoIcon from "@material-ui/icons/Info";
import PasswordHint from "../pages/login/components/PasswordHint";

const TextBoxStyle = styled.div`
  position: relative;
  width: ${(props) => (props.width ? props.width : "418px")};

  @media ${themeSizes.mobile} {
    width: 100%;
  }

  > div {
    display: flex;
    align-items: center;
    margin-top: ${(props) => (props.check === "ekycInput" ? "0px" : "32px")};
    padding: 8px 8px 8px 0;
    border: 1px solid ${(props) => (props.error ? "#E23A3A" : "#cbd5e1")};
    background-color: #F8FAFC;
    border-radius: 8px;
    transition: all 0.25s ease;

    &:focus-within {
      border-color: #4770C1;
      background-color: #ffffff;
      box-shadow: 0 0 0 3px rgba(71, 112, 193, 0.15);
    }

    > p {
      padding-top: 4px;
      margin: 0;
      font-weight: ${semiBold};
      font-size: ${font.base};
      line-height: ${lineHeight.medium};
      color: ${(props) => (props.color ? props.color : "#4770C1")};
    }
    svg {
      flex-shrink: 0;
      position: relative;
      &:first-child {
        animation: blowUp 1s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
      }
      &:last-child {
        top: 1px;
      }
    }
    @keyframes blowUp {
      0% {
        opacity: 0;
        transform: translateY(8px);
      }
      100% {
        opacity: 1;
        transform: translateY(1px);
      }
    }
  }
  label {
    ${microHeading.regularEKYC}
    color: ${black500};
    display: inline-block;
    position: absolute;
    z-index: 0;
    left: 10px;
    top: 10px;
    transition: all 0.2s ease-in;
    ${(props) =>
      props.fieldActive &&
      css`
        margin-top: 6px;
        transform: translateY(-40px);
      `};
  }
  input {
    ${(props) =>
      props.check === "ekycInput" ? microHeading.regular : microHeading.bold}

    flex: 1;
    min-width: 0;
    position: relative;
    color: ${black600};
    border: none;
    outline: none;
    z-index: 1;
    background: transparent;
    padding-left: 12px;
    padding-right: 8px;
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
      transition: background-color 5000s ease-in-out 0s;
    }
    &::-webkit-input-placeholder {
      color: ${black600};
    }
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
`;
const ErrorMessage = styled.span`
  ${baseCaption}
  color: ${cinnabar300};
  margin: 4px 0 0 0;
  display: inline-block;
`;

const HighLightBorderStyle = styled.span`
  border: 1px solid ${(props) => (props.color ? props.color : "black")};
  border-radius: 2px;
  width: ${(props) => (props.width ? props.width : 0)};
  display: block;
  position: absolute;
  z-index: 1;
  margin-top: -1px;
`;
const OutSideTextBox = styled.span`
  position: absolute;
  right: -29px;
  top: 11px;
`;

const Label = styled.label`
  ${microHeading.regular}
  color: ${black400};
`;

export const MobileTextBox = ({
  labelName,
  type,
  name = "",
  onChange = () => {},
  rightIcon = {},
  leftIcon = {},
  error = false,
  errorMessage = "",
  passwordRecommend = {},
  outsideRightIcon,
  subElement,
  value,
  isReadOnly = false,
  check,
  placeholder,
  width,
  max,
  showHint=false
}) => {
  const [fieldActive, setFieldActive] = useState(false || isReadOnly);
  const { passwordType = "", color: passwordColor } = passwordRecommend || {};

  useEffect(() => {
    if (value && check !== "ekycInput") {
      setFieldActive(true);
    }
  }, [value]);

  const activateFocus = () => {
    if (check !== "ekycInput") {
      setFieldActive(true);
    }
  };
  const disableFocus = (event) => {
    if (event.target.value === "" && check !== "ekycInput") {
      setFieldActive(false);
    }
  };

  return (
    <>
      {check === "ekycInput" && <Label>{labelName}</Label>}

      <TextBoxStyle
        error={error}
        color={passwordColor}
        fieldActive={fieldActive}
        check={check}
        width={width}
      >
        {check !== "ekycInput" && <label>{labelName}</label>}
        <div>
          {leftIcon.appearOnFocus
            ? fieldActive
              ? leftIcon.icon
              : null
            : leftIcon.icon}
          {isReadOnly ? (
            <input type={type} value={value} name={name} readOnly />
          ) : (
            <input
              type={type}
              name={name}
              onChange={onChange}
              onFocus={activateFocus}
              onBlur={disableFocus}
              placeholder={check === "ekycInput" ? placeholder : ""}
              value={value}
              max={10}
            />
          )}
          {passwordType ? <p>{passwordType}</p> : null}
          {rightIcon && (rightIcon.icon || rightIcon.appearOnFocus) ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "8px",
                flexShrink: 0,
                cursor: "pointer",
              }}
            >
              {rightIcon.appearOnFocus
                ? fieldActive
                  ? rightIcon.icon
                  : null
                : rightIcon.icon}
            </div>
          ) : null}
            {showHint && (
          <div
            style={{
              position: "absolute",
              right: "-34px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              zIndex: 2,
            }}
          >
            <ToolTip
              icon={<InfoIcon style={{ color: "#000", width: 25, height: 25}} />}
              content={<PasswordHint />}
            />
          </div>
        )}
        </div>
        <OutSideTextBox>{outsideRightIcon}</OutSideTextBox>

        {/* Password highlight */}
        {passwordRecommend?.width ? (
          <HighLightBorderStyle
            color={passwordColor}
            width={passwordRecommend.width}
          />
        ) : null}

        {/* Error message */}
        {error && errorMessage ? (
          React.isValidElement(errorMessage) ? (
            errorMessage
          ) : errorMessage.length ? (
            <ErrorMessage>{errorMessage}</ErrorMessage>
          ) : null
        ) : null}

        {/* {passwordRecommend && passwordRecommend?.width ? (
          <HighLightBorderStyle
            color={passwordColor}
            width={passwordRecommend?.width}
          />
        ) : null}
        {error && errorMessage.length ? (
          <ErrorMessage>{errorMessage}</ErrorMessage>
        ) : null} */}
        {subElement}
      </TextBoxStyle>
    </>
  );
};
